import SettingsContent from '../Wrapper';
import Index from './Index.vue';
import { frontendURL } from '../../../../helper/URLHelper';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/arc'),
      component: SettingsContent,
      props: {
        headerTitle: 'ARC_MGMT.HEADER',
        icon: 'target',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'arc_journey_settings_index',
          roles: ['administrator', 'agent'],
          component: Index,
        },
      ],
    },
  ],
};
